// Copied from ds/src/app/layouts/Sideblock/Sidebar/Menu/Group/MenuItem.tsx
// Changed: removed react-i18next (use data.title directly), removed Counter badge
import clsx from 'clsx';
import { NavLink } from 'react-router';
import invariant from 'tiny-invariant';

import { useBreakpointsContext } from '@/ds/contexts/breakpoint/context';
import { useSidebarContext } from '@/ds/contexts/sidebar/context';
import { type NavigationTree } from '@/ds/types/navigation';
import { navigationIcons } from '@/app/navigation/icons';

export function MenuItem({ data }: { data: NavigationTree }) {
  const { icon, path, title } = data;
  const { lgAndDown } = useBreakpointsContext();
  const { close } = useSidebarContext();

  invariant(icon && navigationIcons[icon], `[MenuItem] Icon ${icon} not found in navigationIcons`);

  invariant(path, '[MenuItem] path is required but not found');

  const Icon = navigationIcons[icon];

  const handleMenuItemClick = () => lgAndDown && close();

  return (
    <div className="relative flex px-3">
      <NavLink
        to={path}
        onClick={handleMenuItemClick}
        className={({ isActive }) =>
          clsx(
            'group min-w-0 flex-1 rounded-md px-3 py-2 font-medium outline-hidden transition-colors ease-in-out',
            isActive
              ? 'text-primary-600 dark:text-primary-400'
              : 'dark:text-dark-200 dark:hover:bg-dark-300/10 dark:hover:text-dark-50 dark:focus:bg-dark-300/10 text-gray-800 hover:bg-gray-100 hover:text-gray-950 focus:bg-gray-100 focus:text-gray-950'
          )
        }
      >
        {({ isActive }) => (
          <>
            <div
              data-menu-active={isActive}
              className="text-xs-plus flex min-w-0 items-center gap-2 tracking-wide"
            >
              <div className="flex min-w-0 items-center gap-3">
                {Icon && (
                  <Icon
                    className={clsx(
                      'size-5 shrink-0 stroke-[1.5]',
                      !isActive && 'opacity-80 group-hover:opacity-100'
                    )}
                  />
                )}
                <span className="truncate">{title}</span>
              </div>
            </div>
            {isActive && (
              <div className="bg-primary-600 dark:bg-primary-400 absolute top-1 bottom-1 w-1 ltr:left-0 ltr:rounded-r-full rtl:right-0 rtl:rounded-l-lg" />
            )}
          </>
        )}
      </NavLink>
    </div>
  );
}
